import {
  BrickPack_SlopedBricksPartOne,
  BrickPack_MinifigUtensilsPartOne,
  BrickPack_BioniclesPartOne,
  BrickPack_AnimalsPartOne,
  BrickPack_MinifigUtensilsPartTwo,
  BrickPack_BioniclesPartTwo,
  BrickPack_CircularBricks,
  BrickPack_MinifigHair,
  BrickPack_TechnicBricks,
  BrickPack_MinifigHeadgear,
} from "../state/BrickActions/ActionInfo/BrickPackActions";

// Map brick IDs to their source brick pack
export const getBrickPackForBrick = (
  brickId: string,
): { id: string; title: string } | null => {
  const brickPacks = [
    BrickPack_SlopedBricksPartOne,
    BrickPack_MinifigUtensilsPartOne,
    BrickPack_BioniclesPartOne,
    BrickPack_AnimalsPartOne,
    BrickPack_MinifigUtensilsPartTwo,
    BrickPack_BioniclesPartTwo,
    BrickPack_CircularBricks,
    BrickPack_MinifigHair,
    BrickPack_TechnicBricks,
    BrickPack_MinifigHeadgear,
  ];

  for (const pack of brickPacks) {
    // Check if this brick is in the pack's outcome array
    const isInPack = pack.outcome.some(
      (outcome) => outcome.brickId === brickId,
    );

    if (isInPack) {
      return {
        id: pack.id,
        title: pack.title,
      };
    }
  }

  return null;
};
